import { render, staticRenderFns } from "./CriteriaGroupsList.vue?vue&type=template&id=2c007b26&scoped=true"
import script from "./CriteriaGroupsList.vue?vue&type=script&lang=js"
export * from "./CriteriaGroupsList.vue?vue&type=script&lang=js"
import style0 from "./CriteriaGroupsList.vue?vue&type=style&index=0&id=2c007b26&prod&lang=css"
import style1 from "./CriteriaGroupsList.vue?vue&type=style&index=1&id=2c007b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c007b26",
  null
  
)

export default component.exports